import {
  createRootRoute,
  Outlet,
  ErrorComponentProps,
} from "@tanstack/react-router";
import ThemeProvider from "@/components/theme-provider";
import { ThemeAwareToaster } from "@/components/theme-aware-toaster";
import { Analytics } from "@vercel/analytics/react";
import { ErrorComponent } from "@/components/errors/error-component";
import { AIContextProvider } from "@/components/context/ai-context";
import { LicenseGate } from "@/lib/licensing/license-gate";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import { useRouter, useRouterState } from "@tanstack/react-router";
import { isPublicSitePath } from "@/lib/sites/paths";

function RootComponent() {
  const router = useRouter();
  // Sitio público en la app (`/s/<slug>`): nada de la licencia del ERP.
  const publicSite = useRouterState({ select: (s) => isPublicSitePath(s.location.pathname) });
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AIContextProvider>
        <ThemeAwareToaster />
        <LicenseGate publicSite={publicSite}>
          <div className="min-h-screen bg-accent/50">
            <Outlet />
          </div>
          <Analytics />
{/*
          {import.meta.env.PROD ? null : (
            <TanStackDevtools
              plugins={[
                {
                  name: "Router",
                  render: <TanStackRouterDevtoolsPanel router={router} />,
                },
              ]}
            />
          )}*/}
        </LicenseGate>
      </AIContextProvider>
    </ThemeProvider>
  );
}

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <div className="min-h-screen bg-accent/50 overflow-x-hidden">
        <ErrorComponent
          error={error}
          reset={reset}
          context={{
            route: "/__root",
          }}
        />
      </div>
      <ThemeAwareToaster />
    </ThemeProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
});
